import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'widgets/Button';
import colors from 'assets/styles/jsVariables/colors';
import LabelledInput from 'components/LabelledInput';

export default function ResetEmail({
  input, action, description, buttonLabel
}) {
  return (
    <React.Fragment>
      <FormattedMessage id={description} />
      <div
        style={{
          marginTop: '30px',
          position: 'relative'
        }}
      >
        <LabelledInput
          isError={input.isError}
          name={input.name}
          onChange={input.onChange}
          iconName={input.iconName}
          placeholder={input.placeholder}
          labelText={input.labelText}
          value={input.value}
          onEnter={input.onEnter}
          cssStylesInput={input.cssStylesInput}
          errorText={input.errorText}
          autoFocus={input.autoFocus}
          errorStyle={{ left: 0 }}
        />
      </div>
      <div
        style={{
          marginTop: '30px'
        }}
      >
        <Button
          id="authAction"
          cssStyles={{
            root: action.cssAuthButtonRootStyle,
            label: action.cssAuthButtonCssLabelStyle,
          }}
          style={{
            background: action.isProcessing ?
              colors.disabledLighterCyan :
              colors.lighterCyan
          }}
          disabled={action.isProcessing}
          onClick={action.onClick}
        >
          <FormattedMessage id={buttonLabel} />
        </Button>
      </div>
    </React.Fragment>
  );
}

ResetEmail.propTypes = {
  input: PropTypes.object.isRequired,
  action: PropTypes.object.isRequired,
  description: PropTypes.string,
  buttonLabel: PropTypes.string
};

ResetEmail.defaultProps = {
  description: 'resetEmail.modal.description',
  buttonLabel: 'resetEmail.modal.action.buttonLabel'
};



// WEBPACK FOOTER //
// ./src/components/ModalContent/ResetEmail.jsx